import {useCallback} from 'react';
import classnames from 'classnames';
import Tooltip, {TooltipTrigger} from '@/components/Tooltip';
import styles from './index.module.scss';

interface ButtonProps {
    onClick?: (e: React.MouseEvent) => void;
    disabled?: boolean;
    tooltip?: string;
    style?: React.CSSProperties;
}

const Button: React.FC<ButtonProps> = (props) => {
    const {
        onClick,
        disabled,
        tooltip,
    } = props;
    const handleClick = useCallback((e) => {
        if (disabled) {
            return;
        }
        onClick && onClick(e);
    }, [disabled, onClick]);

    return (<Tooltip
        trigger={TooltipTrigger.Hover}
        content={tooltip}
        className={styles.previewTooltip}
    >
        <div
            onClick={handleClick}
            className={classnames(
                styles.previewButton,
                disabled && styles.previewDisabled
            )}
            style={props.style}
        >
            {props.children}
        </div>
    </Tooltip>);
};

export default Button;
